export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14650.c3b98b40.jpg";